import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancelSubscription: {
    id: 'mac.licenses.cancel.subscription',
    defaultMessage: 'Cancel subscription',
  },
  cancelTrial: {
    id: 'mac.licenses.cancel.trial',
    defaultMessage: 'Cancel trial',
  },
  deactivatedEndedTrial: {
    id: 'mac.licenses.deactivated.trial.message',
    defaultMessage: 'Deactivated - Your trial period has ended.',
  },
  convert: {
    id: 'mac.licenses.convert',
    defaultMessage: 'convert',
  },
  contactUs: {
    id: 'mac.licenses.contact-us',
    defaultMessage: 'contact us',
  },
  deactivatedNoRenewalAction: {
    id: 'mac.licenses.deactivated.no.renewal.action',
    defaultMessage: 'Deactivated - If you wish to reactivate your instance, please {contactLink}',
  },
  deactivatedProvidePayment: {
    id: 'mac.licenses.deactivated.provide.payment',
    defaultMessage:
      'Deactivated -  Please {paymentLink} to reactivate your instance. {br} If you have any questions, please {contactLink}.',
  },
  provideValidPaymentDetails: {
    id: 'mac.licenses.provide.valid.payment.details',
    defaultMessage: 'provide valid payment details',
  },
  inactive: {
    id: 'mac.licenses.inactive',
    defaultMessage: 'Inactive',
  },
  active: {
    id: 'mac.licenses.active',
    defaultMessage: 'Active',
  },
  renewsOn: {
    id: 'mac.licenses.renews.on',
    defaultMessage: 'Renews On',
  },
  expirationDate: {
    id: 'mac.licenses.expiration.date',
    defaultMessage: 'Expiration Date',
  },
  paymentMethod: {
    id: 'mac.licenses.payment.method',
    defaultMessage: 'Payment Method',
  },
  editCreditCard: {
    id: 'mac.licenses.edit.credit.card',
    defaultMessage: 'Edit Credit Card',
  },
  providePaymentDetails: {
    id: 'mac.licenses.provide.payment.details',
    defaultMessage: 'Provide Payment Details',
  },
  trial: {
    id: 'mac.licenses.trial',
    defaultMessage: 'Trial',
  },
  subscription: {
    id: 'mac.licenses.subscription',
    defaultMessage: 'Subscription',
  },
  cancelCloudCubscription: {
    id: 'mac.licenses.cancel.cloud.cubscription',
    defaultMessage:
      'Canceling your Cloud subscription will deactivate the service and your instance will go offline. This cannot be undone.',
  },
  contactDetails: {
    id: 'review.contact-details',
    defaultMessage: 'Contact details',
  },
  technicalAddressOnInvoice: {
    id: 'mac.licenses.technical.address.on.invoice',
    defaultMessage:
      'The primary technical contact’s postal address is the address that will reflect in the invoice.',
  },
  technicalContacts: {
    id: 'mac.licenses.technical.contacts',
    defaultMessage: 'Technical Contacts',
  },
  addBtn: {
    id: 'migrate.non-billing-user.search.add',
    defaultMessage: 'Add',
  },
  billingContacts: {
    id: 'mac.licenses.billing.contacts',
    defaultMessage: 'Billing Contacts',
  },
  name: {
    id: 'mac.lecenses.name',
    defaultMessage: 'Name',
  },
  SEN: {
    id: 'change.search.label.sen',
    defaultMessage: 'SEN',
  },
  URL: {
    id: 'mac.licenses.url',
    defaultMessage: 'URL',
  },
  addressDetails: {
    id: 'mac.licenses.address.details',
    defaultMessage: 'Address Details',
  },
  updateAddressDetails: {
    id: 'mac.licenses.update.address.details',
    defaultMessage: 'Update Address Details',
  },
  automaticallyChargedCardMessage: {
    id: 'mac.licenses.automatically.charged.card.message',
    defaultMessage:
      "Your credit card will be automatically charged for the following month's subscription on {endDate} if the subscription has not been cancelled before this date.",
  },
  notAutomaticallyRenewedProduct: {
    id: 'mac.licenses.not.automatically.renewed.product',
    defaultMessage: 'Your product subscription will not be automatically renewed. ',
  },
  contactToRenew: {
    id: 'mac.licenses.contact.to.renew',
    defaultMessage: 'Please {contactLink} if you wish to renew your subscription.',
  },
  updateEndDateMessage: {
    id: 'mac.licenses.update.endDate.message',
    defaultMessage:
      'This license is valid until {endDate}. To continue using your software past that date, you must purchase a renewal.',
  },
  organization: {
    id: 'mac.licenses.organization',
    defaultMessage: 'Organization',
  },
  licenseKey: {
    id: 'mac.licenses.license.key',
    defaultMessage: 'License Key',
  },
  viewLicense: {
    id: 'mac.licenses.view.license',
    defaultMessage: 'View License',
  },
  actions: {
    id: 'mac.licenses.actions',
    defaultMessage: 'Actions',
  },
  upgrade: {
    id: 'navigation.header.menu.upgrade',
    defaultMessage: 'Upgrade',
  },
  download: {
    id: 'mac.licenses.download',
    defaultMessage: 'Download {description}',
  },
  downloadSource: {
    id: 'mac.licenses.download.source',
    defaultMessage: 'Download Source',
  },
  viewDeveloperLicense: {
    id: 'mac.licenses.view.developer.license',
    defaultMessage: 'View Developer License',
  },
  archive: {
    id: 'mac.licenses.archive',
    defaultMessage: 'Archive',
  },
  history: {
    id: 'mac.licenses.history',
    defaultMessage: 'History',
  },
  lookupButton: {
    id: 'mac.orders.lookup.submit',
    defaultMessage: 'Submit',
  },
});
